<template>
  <div>
    <h5 class="font-medium">Find Near Postcode</h5>

    <UtilTextLink
      v-if="!appIs.auth"
      @click.native.stop.prevent="
        $store.dispatch('modal/showModal', {
          modalName: 'ModalAuthLogin',
          modalData: { redirectToDashboard: false }
        })
      "
      class="text-brand underline font-semibold cursor-pointer block mb-2"
    >
      {{ $t('search.loginToSearchLocation') }}
    </UtilTextLink>

    <template v-else>
      <UtilMessage
        v-if="postcode && (geocodeApi.status === 'error' || geoCodeError)"
        type="error"
        class="mb-2 mt-1"
      >
        Error, try again
      </UtilMessage>

      <FormTextInput
        name="postcode"
        type="search"
        @input="geocodePostcode"
        v-model="postcode"
        placeholder="e.g PO9 6DX"
        autocomplete="nofill"
        class="mt-1"
      />

      <FormSelect
        v-if="search.aroundPostcode"
        name="radius"
        :value="search.aroundRadius"
        @change="changeRadius"
        :items="distanceOptions"
        :emptyFirstOption="false"
      />
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce, get } from 'lodash'
import LegacyApi from '@/lib/api/legacy'
import distanceOptions, { anyDistanceValue } from '@/lib/options/distance'
import FormTextInput from '@/components/forms/elements/FormTextInput'
import FormSelect from '@/components/forms/elements/FormSelect'
import UtilMessage from '@/components/utils/UtilMessage'
import UtilTextLink from '@/components/utils/UtilTextLink'

export default {
  name: 'UtilSearchGeo',
  components: {
    FormTextInput,
    FormSelect,
    UtilMessage,
    UtilTextLink
  },
  data() {
    return {
      geocodeApi: new LegacyApi(),
      geoCodeError: null,
      postcode: '',
      distanceOptions
    }
  },
  computed: {
    ...mapState({
      search: state => state.search
    })
  },
  created() {
    if (this.appIs.auth) {
      this.$store.dispatch('geo/getCountries')
    }

    this.postcode = this.search.aroundPostcode

    // No existing postcode? Let's prefill from location
    if (!this.search.aroundPostcode && this.appIs.auth && get(this.app, 'locations[0].code')) {
      this.postcode = get(this.app, 'locations[0].code')
      this.geocodePostcode(this.postcode)
    }
  },
  methods: {
    changeRadius(radius) {
      this.$store.commit('search/setGeo', {
        aroundRadius: radius
      })

      this.$store.dispatch('search/fetchListings')

      this.$analytics.addEvent({
        category: 'search',
        action: 'Changed radius from postcode',
        label: radius
      })
    },

    geocodePostcode: debounce(async function (postcode) {
      this.geoCodeError = null

      if (postcode.length === 0) {
        this.$store.commit('search/setGeo', {
          aroundLatLng: '',
          aroundRadius: anyDistanceValue,
          aroundPostcode: ''
        })
      } else {
        const country = this.$store.getters['geo/getCountryByCode'](this.app.countryCode)

        if (!country) {
          this.$log.debug('No countries yet')
          return false
        }

        const countryId = country.countryId

        await this.geocodeApi.post('locations.geocode', {
          code: postcode,
          countryId
        })

        if (this.geocodeApi.data.length && this.geocodeApi.data[0].latitude) {
          let geocodeResult = this.geocodeApi.data[0]

          this.$store.commit('search/setGeo', {
            aroundLatLng: `${geocodeResult.latitude},${geocodeResult.longitude}`,
            aroundRadius: this.search.aroundRadius,
            aroundPostcode: geocodeResult.code
          })
        }
      }

      this.$store.dispatch('search/fetchListings')
    }, 500)
  }
}
</script>
